import { render, staticRenderFns } from "./affiliateAlerts.vue?vue&type=template&id=356fa7aa&"
import script from "./affiliateAlerts.vue?vue&type=script&lang=js&"
export * from "./affiliateAlerts.vue?vue&type=script&lang=js&"
import style0 from "./affiliateAlerts.vue?vue&type=style&index=0&id=356fa7aa&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports